"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowEditingControls = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = require("../../Icons/PetSure/Icon");
var _TableProps = require("../TableProps");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const RowEditingControls = _ref => {
  let {
    row,
    onDelete,
    onEdit
  } = _ref;
  const HandleDelete = () => {
    if (onDelete) {
      onDelete(row);
    }
  };
  const HandleEdit = () => {
    onEdit(row);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "rowEditingControls ".concat(row.isSelected ? 'isSelected' : '')
  }, row.isSelected ? /*#__PURE__*/_react.default.createElement("div", {
    className: "controls"
  }, /*#__PURE__*/_react.default.createElement("button", {
    onClick: () => HandleDelete(),
    type: "button",
    className: "button icon_only"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "Delete"), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: "bin"
  })), /*#__PURE__*/_react.default.createElement("button", {
    onClick: () => HandleEdit(),
    type: "button",
    className: "button icon_only"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "Edit"), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: "pencil"
  }))) : /*#__PURE__*/_react.default.createElement("span", null, "\xA0"));
};
exports.RowEditingControls = RowEditingControls;
RowEditingControls.propTypes = {
  row: _propTypes.default.shape(_TableProps.TableRowProps),
  onDelete: _propTypes.default.func,
  onEdit: _propTypes.default.func
};